import { createAction, props } from '@ngrx/store';
import { ReleaseNote } from 'src/app/models/release-note';

export const getReleaseNotes = createAction('[Release Notes] Get Release Notes');

export const getReleaseNotesSuccess = createAction(
  '[Release Notes] Get Release Notes Success',
  props<{ releaseNotes: ReleaseNote[] }>()
);

export const getReleaseNotesError = createAction('[Release Notes] Get Release Notes Error');

export const saveReleaseNote = createAction('[Release Notes] Save Release Note', props<{ releaseNote: ReleaseNote }>());

export const saveReleaseNoteSuccess = createAction('[Release Notes] Save Release Note Success');

export const saveReleaseNoteError = createAction('[Release Notes] Save Release Note Error');

export const deleteReleaseNote = createAction(
  '[Release Notes] Delete Release Note',
  props<{ releaseNoteId: number }>()
);

export const deleteReleaseNoteSuccess = createAction(
  '[Release Notes] Delete Release Note Success',
  props<{ deletedReleaseNoteId: number }>()
);

export const deleteReleaseNoteError = createAction('[Release Notes] Delete Release Note Error');

export const editReleaseNote = createAction('[Release Notes] Edit Release Note', props<{ releaseNote: ReleaseNote }>());

export const editReleaseNoteSuccess = createAction(
  '[Release Notes] Edit Release Note Success',
  props<{ editedReleaseNote: ReleaseNote }>()
);

export const editReleaseNoteError = createAction('[Release Notes] Edit Release Note Error');
